import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, redirectingProfileEnum, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Value (USD)", two_table_header: "Total Value (USD)" },
  { value: "weight", label: "Total Weight (kg)", two_table_header: "Total Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Philippines Imports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  isViewAllGridNew: true,
  showUiTrends: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2020-01-01",
  isImpExpGraph: true,
  isUIGridNew: true,
  isUEGridNew: true,
  bol_type: "bol_number",
  showBolFilter: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("intelSearchPhilippinesImportLatestArrivalDate"),
    getSearchResult: getApiUrl("intelSearchPhilippinesImport"),
    getAnalyticsData: getApiUrl("analytics/intelAnalyticsPhilippinesImport"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_philippines_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_philippines_imports"),
    getShipmentByID: getApiUrl("intelSearchPhilippinesImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfPhilippinesImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/intelAnalyticsPhilippinesImportViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchPhilippinesImportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.ph_import.country_small,
  countryCaps: globalCountryDetails.ph_import.country_caps,
  product_id: globalCountryDetails.ph_import.product_id,
  compare_product_id: globalCountryDetails.ph_import.compareProduct,
  country_CamelCase: globalCountryDetails.ph_import.product_id,
  countryCode: globalCountryDetails.ph_import.countryCode,
  countryType: globalCountryDetails.ph_import.countryType,
  manyCountryType: globalCountryDetails.ph_import.manyCountryType,
  countryTypeCode: globalCountryDetails.ph_import.countryTypeCode,
  redirectionID: globalCountryDetails.ph_import.redirectionID,
  analyticsCountryID: globalCountryDetails.ph_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipment Date Range",
  monthRangeHeading: "Month of Import",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.ph_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    value: "shipmentValue",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    portOfUnlading: "standardUnladingPortName",
  },
  filterObj: {
    consigneeName: "consigneeName",
    shipperName: "shipperName",
    consigneeType: "consigneeType",
    shipperType: "shipperType",
    originCountryRegion: "originCountryRegion",
    exportCountryRegion: "exportCountryRegion",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    consigneeCity: "consigneeCity",
    consigneeProvince: "consigneeProvince",
    arrivalPort: "arrivalPort",
    vesselName: "vesselName",
    weight: "weight",
    shipmentValue: "shipmentValue",
    bolFobValue: "bolFobValue",
    bolNetWeight: "bolNetWeight",
    hsCode: "hsCode",
    incoterm: "incoterm",
    modeOfTransport: "modeOfTransport",
    derivedShipperMasterName: "derivedShipperMasterName",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    standardUnladingPortName: "standardUnladingPortName",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    weight: "weight",
    shipmentValue: "shipmentValue",
    bolFobValue: "bolFobValue",
    bolNetWeight: "bolNetWeight",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    weight: [],
    shipmentValue: [],
    bolFobValue: [],
    bolNetWeight: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    originCountryRegion: "originCountry",
    exportCountryRegion: "exportCountry",
    countryOfDestinationRegion: "countryOfDestination",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    consigneeName: [],
    shipperName: [],
    consigneeType: [],
    shipperType: [],
    originCountryRegion: [],
    exportCountryRegion: [],
    countryOfDestinationRegion: [],
    consigneeCity: [],
    consigneeProvince: [],
    arrivalPort: [],
    vesselName: [],
    sections: [],
    weight: [],
    shipmentValue: [],
    bolFobValue: [],
    bolNetWeight: [],
    hsCode: [],
    incoterm: [],
    modeOfTransport: [],
    derivedShipperMasterName: [],
    derivedConsigneeMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    standardUnladingPortName: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    consigneeName: false,
    consigneeType: false,
    shipperName: false,
    shipperType: false,
    originCountryRegion: false,
    exportCountryRegion: false,
    countryOfDestinationRegion: false,
    consigneeCity: false,
    consigneeProvince: false,
    arrivalPort: false,
    vesselName: false,
    sections: false,
    weight: false,
    shipmentValue: false,
    bolFobValue: false,
    bolNetWeight: false,
    hsCode: false,
    incoterm: false,
    modeOfTransport: false,
    derivedShipperMasterName: false,
    derivedConsigneeMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    standardUnladingPortName: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },

  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "16", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Standardized Name", categoryName: "consigneeDetails", eventKey: "17", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: "shipperDetails", eventKey: "1", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: "consigneeDetails", eventKey: "5", key: "consigneeName", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Type", categoryName: "shipperDetails", eventKey: "2", key: "shipperType", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search in Shipper Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country Of Origin", categoryName: "shipperDetails", eventKey: "3", key: "originCountryRegion", altKey: "originCountry", type: filterType.localizeFilter, label: "Country Of Origin", viewAllPlaceHolder: "Search in Country Of Origin Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country Of Export", categoryName: "shipperDetails", eventKey: "4", key: "exportCountryRegion", altKey: "exportCountry", type: filterType.localizeFilter, label: "Country Of Export", viewAllPlaceHolder: "Search in Country Of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country Of Import", categoryName: "consigneeDetails", eventKey: "4", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country Of Import", viewAllPlaceHolder: "Search in Country Of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: "consigneeDetails", eventKey: "6", key: "consigneeType", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Consignee Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee City", categoryName: "consigneeDetails", eventKey: "7", key: "consigneeCity", type: filterType.normalFilter, label: "Consignee City", viewAllPlaceHolder: "Search in Consignee City Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Province", categoryName: "consigneeDetails", eventKey: "8", key: "consigneeProvince", type: filterType.normalFilter, label: "Consignee Province", viewAllPlaceHolder: "Search in Consignee Province Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port of Unlading", categoryName: "ports", eventKey: "9", key: "standardUnladingPortName", type: filterType.normalFilter, label: "Port Of Unlading", viewAllPlaceHolder: "Search in Port Of Unlading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Vessel Name", categoryName: "carrierDetails", eventKey: "10", key: "vesselName", type: filterType.normalFilter, label: "Vessel Name", viewAllPlaceHolder: "Search in Vessel Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "11", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: "cargoDetails", eventKey: "11", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight", categoryName: "cargoDetails", eventKey: "13", key: "weight", type: filterType.boxFilter, label: "Weight (kg)", viewAllPlaceHolder: "Search in Weight Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "14", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Shipment Value Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Incoterm", categoryName: "freightType", eventKey: "15", key: "incoterm", type: filterType.normalFilter, label: "Incoterm", viewAllPlaceHolder: "Search in Incoterm Filter", emptyFilterText: "", searchFilterString: "", isNoTransform: true },
    { heading: "Filter by Mode of Transportation", categoryName: "freightType", eventKey: "20", key: "modeOfTransport", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by BOL Shipment Value (USD)", categoryName: "cargoDetails", eventKey: "18", key: "bolFobValue", type: filterType.boxFilter, label: "BOL Shipment Value (USD)", viewAllPlaceHolder: "Search in BOL Shipment Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by BOL Weight (Kg)", categoryName: "cargoDetails", eventKey: "19", key: "bolNetWeight", type: filterType.boxFilter, label: "BOL Weight (KG)", viewAllPlaceHolder: "Search in BOL Weight Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "bol_number", label: "Bill of Lading Number" },
    { key: "derived_hs_code", label: "HS Code" },
    { key: "shipper_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "consignee_name", label: "Consignee Name" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "consignee_address", label: "Consignee Address" },
    { key: "product_description", label: "Product Description" },
    { key: "vessel_name", label: "Vessel Name" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
  ],
  shipmentSorting: [
    { columnKey: "date_of_arrival", value: "date", isDefault: true },
    { columnKey: "net_weight", value: "weight", isDefault: false },
    { columnKey: "fob_value_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "date_of_arrival",
    weight: "net_weight",
    shipment_value: "fob_value_usd",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Weight", key: "total_weight", valuePrefix: "", valueSuffix: "kg" },
    { label: "Total Shipment Value (USD)", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "exportCountryRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "country_of_origin", filterKey: "originCountryRegion", label: "Countries of Origin", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "port_of_arrival" },
    { key: "country_of_export", filterKey: "exportCountryRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "port_of_arrival" },
    { key: "port_of_arrival", filterKey: "arrivalPort", label: "Ports Of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_origin" },
    { key: "consignee_city", filterKey: "consigneeCity", label: "Consignee Cities", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_origin" },
    { key: "consignee_province", filterKey: "consigneeProvince", label: "Consignee Provinces", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_origin" },
    { key: "vessel_name", filterKey: "vesselName", label: "Vessels", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_origin" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "derived_mode_of_transport_english", filterKey: "modeOfTransport", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "country_of_origin" },
    // { key: "trade_route_export_country_to_port_of_arrival", filterKey1: "exportCountryRegion", filterKey2: "standardUnladingPortName", label: "Trade Routes (Country of Export → Port of Unlading)", headerOne: "Country of Export", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    // { key: "trade_route_origin_country_to_export_country_to_port_of_arrival", filterKey1: "originCountryRegion", filterKey2: "exportCountryRegion", filterKey3: "standardUnladingPortName", label: "Trade Routes (Country of Origin → Country of Export → Port of Unlading)", headerOne: "Country of Origin", headerTwo: "Country of Export", headerThree: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", filterThree: "filterField3", keyOne: "field1Country", keyTwo: "field2Country", keyThree: "field3Country", cityOne: "field1", cityTwo: "field2", cityThree: "field3", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", keyThreeCountryCode: "field3CountryCode", type: analyticsType.topThree, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, grow: 0, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "date_of_arrival", name: "Arrival Date", selector: "date_of_arrival", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_hs_code", name: "HS Code", selector: "derived_hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_description", name: "Product Description", selector: "product_description", tooltipValue: "product_description", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 30, miWidth: "120px", maWidth: "120px" },
    { key: "net_weight", name: "Weight (kg)", selector: "net_weight", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "110px", maWidth: "110px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "consignee_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_country_of_export", name: "Country Of Export", selector: "derived_country_of_export", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px", isFirstLetterCapital: true },
    { key: "fob_value_usd", name: "Shipment Value (USD)", selector: "fob_value_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "140px", maWidth: "140px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Date of Arrival", value: "date_of_arrival", dateFormat: true, monthFormat: false },
        {
          label: "Bill of Lading Number",
          value: "bol_number",
          capitalize: true,
        },
        { label: "HS Code", value: "derived_hs_code", hideCargo: "bol" },
        { label: "Incoterm", value: "derived_incoterm_code_description_combined" },
        { label: "Mode of Transportation", value: "derived_mode_of_transportation" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Origin", value: "derived_country_of_origin", countryFlag: true, countryCodeField: "originCountryCode", hideCargo: "bol" },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "shipper_name", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Shipper Name", value: "shipper_name" },
        { label: "Shipper Type", value: "derived_is_exporter" },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Port of Unlading", value: "derived_port_of_arrival", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "consignee_name", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Consignee Name", value: "consignee_name" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Consignee Address", value: "consignee_address", isReadMore: true, readMoreLength: 45 },
        { label: "Consignee City", value: "derived_consignee_city" },
        { label: "Consignee Province", value: "derived_consignee_province" },
        { label: "Consignee Email", value: "consignee_email" },
        { label: "Consignee Phone", value: "consignee_phone" },
        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    // {
    //     id: 4,
    //     title: "Customs Details",
    //     growValue: 6,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     data: [
    //         { label: 'Import Type', value: 'derived_import_type_english', tooltip: true, tooltipField: 'import_type_spanish', capitalize: 'true', },
    //         { label: 'Customs House Name', value: 'customs_house_name', capitalize: 'true', },
    //         { label: 'Customs Agent Code', value: 'derived_customs_agent_code', },
    //         { label: 'Customs Agent Name', value: 'derived_customs_agent_name', capitalize: 'true', },
    //         { label: 'Customs Agency Name', value: 'customs_agency_name', capitalize: 'true', },
    //     ]
    // },
    {
      id: 4,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [{ label: "Vessel Name", value: "vessel_name", capitalize: "true" }],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      hideCargo: "bol",
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "HS Code", value: "derived_hs_code" },
        { label: "Product Description", value: "product_description" },
        { label: "Quantity of Package", value: "quantity_of_package" },
        { label: "Package Unit", value: "package_unit" },
        { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_quantity_unit", isCommaFormat: true },
        { label: "Gross Weight", value: "gross_weight", valueSuffix: " kg", isCommaFormat: true },
        { label: "Net Weight", value: "net_weight", valueSuffix: " kg", isCommaFormat: true },
        { label: "FOB Value", value: "fob_value_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Freight", value: "freight_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Insurance", value: "insurance_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "CIF Value", value: "cif_value_usd", valuePrefix: "USD ", isCommaFormat: true },
      ],
    },
    {
      id: 6,
      title: "Bill of Lading Details",
      growValue: 6,
      isHeader: false,
      altTitle: "Cargo Details",
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "BOL FOB Value", valuePrefix: "USD ", value: "bol_fob_value_usd" },
        { label: "BOL CIF Value", valuePrefix: "USD ", value: "bol_cif_value_usd" },
        { label: "BOL Gross Weight", valueSuffix: " kg", value: "bol_gross_weight" },
        { label: "BOL Net Weight", valueSuffix: " kg", value: "bol_net_weight" },
      ],
    },
    {
      id: 6,
      title: "Shipment Level Details",
      growValue: 12,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      mainKey: "shipment_level_details",
      uniqueKey: "id",
      isBolContainer: true,
      hideCargo: "bol",
      data: [
        { label: "Country of Origin", value: "derived_country_of_origin" },
        { label: "HS Code", value: "derived_hs_code" },
        { label: "Product Description", value: "product_description" },
        { label: "Quantity of Package", value: "quantity_of_package" },
        { label: "Package Unit", value: "package_unit" },
        { label: "Quantity", value: "quantity" },
        { label: "Quantity", value: "derived_quantity_unit" },
        { label: "Gross Weight", valueSuffix: " kg", value: "gross_weight" },
        { label: "Net Weight", valueSuffix: " kg", value: "net_weight" },
        { label: "FOB Value", valuePrefix: "USD ", value: "fob_value_usd" },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Freight", valuePrefix: "USD ", value: "freight_usd" },
        { label: "Insurance", valuePrefix: "USD ", value: "insurance_usd" },
        { label: "CIF Value", valuePrefix: "USD ", value: "cif_value_usd" },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your shipment basis payment date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for Philippines Imports Shipments", description: "HS Codes and Consignees", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique consignees and shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  defaultUeUiSecondLevelKey: "country_of_origin",
  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    country_of_origin: "Countries of Origin",
    country_of_export: "Countries of Export",
    port_of_arrival: "Port of Unlading",

    vessel_name: "Vessel Name",
    consignee_city: "Consignee City",
    consignee_province: "Consignee Province",
    // hs_code: "HS Code",
    // trade_route_export_country_to_port_of_arrival: "Trade Routes (Country of Export → Port of Unlading)",
    // trade_route_origin_country_to_export_country_to_port_of_arrival: "Trade Routes (Country of Origin → Country of Export → Port of Unlading)",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const PhilippinesImportsSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default PhilippinesImportsSearch;
